const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';

export function getToken() {
  return localStorage.getItem('token');
}

export function setToken(token) {
  localStorage.setItem('token', token);
}

export function removeToken() {
  localStorage.removeItem('token');
  localStorage.removeItem('token_original');
}

// GO! (como en SPG): el administrador entra como otro usuario. Su propio pase se guarda
// aparte para volver. Se recarga la página para que todo se cargue como esa persona.
export function entrarGo(tokenGo) {
  localStorage.setItem('token_original', getToken());
  setToken(tokenGo);
  window.location.reload();
}

export function salirGo() {
  const original = localStorage.getItem('token_original');
  localStorage.removeItem('token_original');
  if (original) setToken(original);
  else localStorage.removeItem('token');
  window.location.reload();
}

export function enGo() {
  return !!localStorage.getItem('token_original');
}

export async function api(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  if (res.status === 401) {
    removeToken();
    window.location.reload();
    return;
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error del servidor');
  return data;
}

// Subida de archivos (FormData): sin Content-Type, lo pone el navegador con el boundary.
export async function apiForm(path, formData, options = {}) {
  const token = getToken();
  const res = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    ...options,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  if (res.status === 401) {
    removeToken();
    window.location.reload();
    return;
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error del servidor');
  return data;
}

// Abre un archivo protegido (necesita el token) en una pestaña nueva.
// La pestaña se abre ANTES de pedir el archivo: si se abre después, el móvil la bloquea.
export async function abrirArchivo(path) {
  const ventana = window.open('', '_blank');
  const token = getToken();
  const res = await fetch(`${API_URL}${path}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) {
    if (ventana) ventana.close();
    let msg = 'No se pudo abrir el documento';
    try { msg = (await res.json()).error || msg; } catch (_) {}
    throw new Error(msg);
  }
  const url = URL.createObjectURL(await res.blob());
  if (ventana) ventana.location.href = url;
  else window.location.href = url;
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// Descarga un archivo protegido y devuelve una URL local (blob:) para mostrarlo en la página,
// por ejemplo las páginas de un documento pendiente de firma. Hay que liberarla con revokeObjectURL.
export async function urlArchivo(path) {
  const token = getToken();
  const res = await fetch(`${API_URL}${path}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) {
    let msg = 'No se pudo cargar el documento';
    try { msg = (await res.json()).error || msg; } catch (_) {}
    throw new Error(msg);
  }
  return URL.createObjectURL(await res.blob());
}
